import { render, staticRenderFns } from "./TrocarApresentante.vue?vue&type=template&id=2d50e5f5"
import script from "./TrocarApresentante.vue?vue&type=script&lang=js"
export * from "./TrocarApresentante.vue?vue&type=script&lang=js"
import style0 from "./TrocarApresentante.vue?vue&type=style&index=0&id=2d50e5f5&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d50e5f5')) {
      api.createRecord('2d50e5f5', component.options)
    } else {
      api.reload('2d50e5f5', component.options)
    }
    module.hot.accept("./TrocarApresentante.vue?vue&type=template&id=2d50e5f5", function () {
      api.rerender('2d50e5f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TrocarApresentante.vue"
export default component.exports